import { connect } from 'react-redux'
import NumbersChangeUsagePlanModal from './NumbersChangeUsagePlanModal'
import {
  getChangeUsagePlanFee,
  getSuitableUsagePlans,
  changeUsagePlan,
} from 'features/Numbers/Numbers.actions'
import { flow, get } from 'lodash'
import { reduxForm } from 'redux-form'

const formName = 'usagePlanChange'

const stateToProps = ({ numbers }, { serviceId }) => {
  const usagePlanFee = get(numbers, ['usagePlanFees', serviceId], {})
  const usagePlans = get(numbers, ['suitableUsagePlans', serviceId], {})

  return {
    loading: usagePlanFee.loading || usagePlans.loading,
    fee: usagePlanFee.fee,
    date: usagePlanFee.date,

    usagePlanOptions: usagePlans.all
      ? usagePlans.all.map(usagePlan => ({
          name: `${usagePlan.name} - ${usagePlan.alias}`,
          value: usagePlan.alias,
        }))
      : [],
  }
}

const dispatchToProps = {
  getChangeUsagePlanFee,
  getSuitableUsagePlans,
  changeUsagePlan,
}

export default flow(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(NumbersChangeUsagePlanModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersChangeUsagePlanModal/NumbersChangeUsagePlanModal.container.js